import type { ReactNode } from 'react';

export interface ListRowProps {
  label: string;
  description?: string;
  /** Bal oldali elem a szöveg ELŐTT, pl. profilkép. */
  leading?: ReactNode;
  /** Jobb oldali érték, pl. „95 kg" vagy „Automatikus". */
  value?: ReactNode;
  onClick?: () => void;
  /** Jobbra mutató nyíl. Alapból kattintható sornál látszik; `false` elrejti (pl. választó-sor). */
  chevron?: boolean;
  disabled?: boolean;
  /** Visszafordíthatatlan/kockázatos művelet (pl. fióktörlés) — piros felirat. */
  danger?: boolean;
}

/** Beállítás-sor. Kattinthatóként gomb, egyébként sima sor. */
export function ListRow({ label, description, leading, value, onClick, chevron, disabled, danger }: ListRowProps) {
  const content = (
    <>
      {leading ? <span className="row__leading">{leading}</span> : null}
      <span className="row__text">
        <span className={danger ? 'row__label row__label--danger' : 'row__label'}>{label}</span>
        {description ? <span className="row__desc">{description}</span> : null}
      </span>
      {value ? <span className="row__value">{value}</span> : null}
      {(chevron ?? Boolean(onClick)) ? (
        <svg
          className="row__chevron"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="m9 6 6 6-6 6" />
        </svg>
      ) : null}
    </>
  );

  if (!onClick) return <div className="row">{content}</div>;

  return (
    <button type="button" className="row" onClick={onClick} disabled={disabled}>
      {content}
    </button>
  );
}

/** Sorok csoportja kártyaként. */
export function List({ children }: { children: ReactNode }) {
  return <div className="list">{children}</div>;
}
